const removeAllFacetsFromAppliedArray = (appliedFacet, listOfIgnoredFacets = ['storeId', 'sortByField', 'sortByDir']) => {
  const currentAppliedFacets = appliedFacet;

  Object.keys(currentAppliedFacets).forEach((appliedFacetKey) => {
    if (!listOfIgnoredFacets.includes(appliedFacetKey)) {
      // Set every facet that's not storeId to an empty array
      currentAppliedFacets[appliedFacetKey] = [];
    }
  });

  return currentAppliedFacets;
};

export default removeAllFacetsFromAppliedArray;
